import script from "./UserMyShosai.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMyShosai.vue?vue&type=script&setup=true&lang=js"

import "./UserMyShosai.vue?vue&type=style&index=0&id=5da5f103&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da5f103"]])

export default __exports__